/*
 * Module for one lonesome report
 */

//DataModel imported because we reqres it
define([
  "marionette",
  "backbone",
  "highcharts/highcharts",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "modules/reportSplit/reports/reportModel",
], function (Marionette, Backbone, Highcharts, $, Messenger, ReportUtilities) {
  "use strict";

  return function (report, renderTo, singleReportModule) {
    if (report.type === "line") {
      let notSpecified = "";
      if (report.options.title === undefined) {
        notSpecified = "\nreport.options.title";
      }
      if (report.options.xAxisTitle === undefined) {
        notSpecified = notSpecified + "\nxAxisTitle";
      }
      if (report.options.yAxisTitle === undefined) {
        notSpecified = notSpecified + "\nyAxisTitle";
      }
      if (report.options.seriesTitle === undefined) {
        notSpecified = notSpecified + "\nseriesTitle";
      }
      if (notSpecified !== "") {
        Messenger.okDialog(
          "The following report options are required for line charts, but were not specified:\n" +
            notSpecified +
            "\n\nThey must be added to the report when it is created on the server.  The report will not be able to display until they are added.",
        );
        return;
      }
      /**
       * This report is more like what one of our real reports will look like, despite it being a made-up report.
       * The reqres call below retieves the data that will be displayed in HighCharts (assigned in the series
       * below).
       *
       * The handler for the reqres calls for dataSets should be placed in dataModel.js to keep them all together;
       * you can find this one by searching for "lineChartData" in dataModel.js.  The same reqres call can be used
       * by other charts that are line charts.
       */
      let dataSet = Messenger.reqres.request("lineChartData", report.href);
      console.log(dataSet);
      /**
       * Ths .once("sync" code here is very important.  This waits for the data to be retrieved from the web server
       * before doing what is inside of it (which is displaying the HighChart).  If this weren't here, we'd wind up
       * with charts that showed nothing because they would be drawn before the data for them arrived.
       */

      singleReportModule.listenTo(
        dataSet,
        "sync",
        function () {
          //dataSet.once("sync", function() {
          //show the single report layout
          singleReportModule.showRegion(singleReportModule.layout);

          Messenger.vent.trigger("report:arrived", report);
          console.log(dataSet);
          /**
           * Retrieve the parameters that the user gave for the configuration.
           */
          let currentTitle = $.t(report.options.title);
          currentTitle = ReportUtilities.figureOutText(currentTitle, true);
          const xAxisTitle = $.t(report.options.xAxisTitle);
          const yAxisTitle = $.t(report.options.yAxisTitle);
          let floor = null;
          if (report.options.minimum) {
            floor = Number(report.options.minimum);
          }
          /**
           * The data comes back as (usually) a Backbone collection.  This works well for retrieving it from the
           * RESTful service on this web server, and generally we'll want to keep it in this format.  However,
           * HighCharts needs it in JSON format to display the chart.  We can get this by simply calling the
           * .toJSON() method on it.  JSON.stringify(dataSet) should also work.
           */
          dataSet = dataSet.toJSON();
          $(function () {
            singleReportModule.createChart({
              chart: {
                type: "line",
              },
              title: {
                text: currentTitle,
              },
              xAxis: {
                allowDecimals: false,
                type: "linear",
                title: {
                  text: xAxisTitle,
                },
                labels: {
                  formatter: function () {
                    return this.value; //this prevents HighCharts from adding a comma for readability.  since this is
                    // a year, we don't want that comma
                  },
                },
                //optionally could also have gridLineWidth: 1
              },
              yAxis: {
                title: {
                  text: yAxisTitle,
                },
                allowDecimals: false,
                min: floor,
              },
              /**
               * This simple line chart only needs one series, and one dataSet.
               */
              series: dataSet[0].lines,
            });
          });
        },
        this,
      );
    }
  };
});
